module.exports = __webpack_public_path__ + "img/banner.1e9ad627.jpg";